/**
 * 신청서 코드
 */
export default {
  Vacation: '222', // 근태
  OtWork: '110', // 연장근무
  Schedule: '301', // 근무스케줄
  Attend: '30', // 출퇴근 변경
  Reward: '42', // 보상휴가
  //CancelVacation: '23', // 근태 취소
  CancelReward: '43', // 보상휴가 취소
  Vaccination: '7051', // 독감예방접종
  EdusApp: '7021', // 학자금신청
  LeaAbsParental: '151', // 육아휴직
  LeaAbsFamily: '153', // 가족돌봄휴직
  LeaAbsInfertility: '154', // 난임치료휴직
  LeaAbsApplication: '155', // 복직신청
  eaAbsExtension: '156', // 휴직연장
  LeaAbsSick: '157', // 공상휴직
  LeaAbsCasualty: '158', // 사상휴직
  LeaAbsNew: '159', // 신상휴직
  LeaAbsExtension: '160', // 휴직연장
  LeaAbsAdd: '152', // 휴직추가
  HolReplaceApp: '310', // 휴일근무사전대체신청
  HolReplaceBoxView: '311', // 휴일근무사전대체 취소신청
  ReCertTenureAppView: '11', // 재직증명신청
  ReCertTenureEngAppView: '12', // 재직증명신청
  ReCertTenureTax1AppView: '16', // 원천징수영수증
  ReCertTenureTax2AppView: '19', // 원천징수부
  ReCertLeaveAppView: '21', // 휴직증명서
  ReCertGabTaxView: '18', // 갑근세증명원
  WorkScheduleTime1: '304', // 시차출퇴근제
  Vacations: '22', // 근태/휴가 신청
  VacationsCancel: '23' // 근태/휴가 취소신청
};
